import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/modules/user";
import { staticRouter } from "@/routers/staticRouter";
import { useGlobalStore } from "@/stores/modules/global";
import { setThemeProperty } from "@/utils/color";
import { getUserInfo } from "@/api/services/userService";
import sensors from "sa-sdk-javascript";
/**
 * @description 📚 路由参数配置简介
 * @param path ==> 路由菜单访问路径
 * @param name ==> 路由 name (对应页面组件 name, 可用作 KeepAlive 缓存标识 && 按钮权限筛选)
 * @param redirect ==> 路由重定向地址
 * @param component ==> 视图文件路径
 * @param meta ==> 路由菜单元信息
 * @param meta.icon ==> 菜单和面包屑对应的图标
 * @param meta.title ==> 路由标题 (用作 document.title || 菜单的名称)
 * @param meta.activeMenu ==> 当前路由为详情页时，需要高亮的菜单
 * @param meta.isLink ==> 路由外链时填写的访问地址
 * @param meta.isHide ==> 是否在菜单中隐藏 (通常列表详情页需要隐藏)
 * @param meta.isFull ==> 菜单是否全屏 (示例：数据大屏页面)
 * @param meta.isAffix ==> 菜单是否固定在标签页中 (首页通常是固定项)
 * @param meta.isKeepAlive ==> 当前路由是否缓存
 * */
const router = createRouter({
    history: createWebHistory(),
    routes: staticRouter,
    strict: false,
    scrollBehavior: () => ({ left: 0, top: 0 })
});

async function queryUserInfo() {
    try {
        const res = await getUserInfo();

        const userStore = useUserStore();

        userStore.userInfo = res || null;
        if (res) {
            // 神策埋点注入用户信息
            sensors.registerPage({
                customer_id: res.actualAccount.id
            });
        }
    } catch {
        void 0;
    }
}

/**
 * @description 路由拦截 beforeEach
 * */
router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore();

    const token = (to.query.token as string) || userStore.token;

    // 2.动态设置标题
    document.title = to.meta.title ? `${to.meta.title}` : "";
    if (token) {
        // 可能是会从 app(链云/船务) + 小程序（链云/船务） 跳转过来的，需要判断是否有 token
        userStore.setToken(token);

        // 根据token查询用户信息

        if (userStore.userInfo === null) {
            await queryUserInfo();
        }
    }
    const globalStore = useGlobalStore();
    if (to.query.theme) globalStore.setTheme(to.query.theme.toString());
    // 入口来源：1 船务小程序/app，2 链云砂石小程序/app。
    const routeAppForm = to.query.app_from;
    const appForm = Array.isArray(routeAppForm) ? routeAppForm[0] : routeAppForm;
    if (appForm) {
        globalStore.setAppForm(appForm.toString());
    } else if (!from.name) {
        // 首屏无来源参数时清空持久化来源，避免上次砂石入口残留导致船务误启用会员次数。
        globalStore.setAppForm("");
    }
    // 设置主题色
    setThemeProperty(globalStore.theme);


    next();
});

/**
 * @description 路由跳转错误
 * */
router.onError(error => {
    console.warn("路由错误", error.message);
});

export default router;
